import React from "react";
import "./WindowButton.scss";
import Window1 from "../../../assets/booking-assets/window-1.svg";
import Window2 from "../../../assets/booking-assets/window-2.svg";
import Window4 from "../../../assets/booking-assets/window-4.svg";
import Window6 from "../../../assets/booking-assets/window-6.svg";
import Window8 from "../../../assets/booking-assets/window-8.svg";

const WindowButton = ({
  windowType,
  handleIncrease,
  handleDecrease,
  state,
}) => {
  const windowTypeDisplay = () => {
    switch (windowType) {
      case 1:
        return <Window1 />;
      case 2:
        return <Window2 />;
      case 4:
        return <Window4 />;
      case 6:
        return <Window6 />;
      case 8:
        return <Window8 />;
      default:
        return (
          <div className="text-xl text-center h-32 flex items-center justify-center">
            Annan typ
          </div>
        );
    }
  };

  return (
    <div
      className="WindowButton flex flex-col items-center rounded-md border border-gray-300 py-8 px-10"
      style={{ borderColor: state > 0 ? "#011E41" : "rgb(209,213,219)" }}
    >
      <div className="mb-10">{windowTypeDisplay()}</div>
      <div className="quantity">
        <button className="rectangle" onClick={handleDecrease}>
          -
        </button>
        <div className="rectangle">{state}</div>
        <button className="rectangle" onClick={handleIncrease}>
          +
        </button>
      </div>
    </div>
  );
};

export default WindowButton;
